import type React from 'react';
import { PlayerCropCard } from './PlayerCropCard';
import { playerCropToDataUri } from '@/lib/transforms';

interface SegmentIdentifierProps {
  playerCrops: Record<string, string>;
  selectedPlayerId: string | null;
  onSelect: (playerId: string) => void;
  disabledPlayerIds?: Set<string>;
}

export const SegmentIdentifier: React.FC<SegmentIdentifierProps> = ({
  playerCrops,
  selectedPlayerId,
  onSelect,
  disabledPlayerIds,
}) => {
  return (
    <div className="grid min-h-0 w-full flex-1 grid-cols-2 grid-rows-2 gap-3">
      {Object.entries(playerCrops).map(([playerId, base64Crop]) => {
        const isDisabled = disabledPlayerIds?.has(playerId) ?? false;
        const imageUrl = playerCropToDataUri(base64Crop);

        return (
          <PlayerCropCard
            key={playerId}
            playerId={playerId}
            imageUrl={imageUrl}
            isSelected={selectedPlayerId === playerId}
            isDisabled={isDisabled}
            onSelect={() => onSelect(playerId)}
          />
        );
      })}
    </div>
  );
};

export default SegmentIdentifier;
